export default __webpack_public_path__ + "static/media/opennedCase.af434efb.mp3";